import { createContext, useContext, useEffect, useState } from "react";

export const LANGS = [
  { code: "fr", label: "FR" },
  { code: "en", label: "EN" },
  { code: "nl", label: "NL" },
];

const STORAGE_KEY = "ice_label_lang";

const translations = {
  fr: {
    "nav.services": "Services",
    "nav.extraits": "Extraits",
    "nav.about": "Studio",
    "nav.contact": "Contact",
    "header.call": "Appeler",

    "hero.eyebrow": "Studio · Bruxelles · Anderlecht",
    "hero.slogan": "Where Music Lives",
    "hero.subtitle":
      "Studio d'enregistrement professionnel. Mix, production sur-mesure et mastering — pensés pour les artistes qui veulent un son net, taillé pour les plateformes.",
    "hero.callBtn": "Appeler",
    "hero.smsBtn": "Envoyer un SMS",
    "hero.seeServices": "Voir les tarifs",
    "hero.reservationTitle": "Réservation",
    "hero.reservationText":
      "Sessions confirmées par téléphone ou SMS uniquement. Ouvert du lundi au samedi, de 9h à 21h — uniquement sur réservation.",
    "hero.hours": "Lun–Sam · 9h–21h",

    "services.eyebrow": "01 — Tarifs",
    "services.title": "Trois services. Un seul standard : pro.",
    "services.desc":
      "Tarifs clairs, sans surprise. Pas d'abonnement, pas de paquets cachés — vous payez la session, point.",
    "services.night": "Sessions de nuit (22h → 8h) : tarif ×2",
    "services.mix.eyebrow": "Mix",
    "services.mix.title": "Session Mix",
    "services.mix.desc":
      "Mix professionnel de vos titres en studio. Ingénieur du son présent, écoute monitoring haut de gamme.",
    "services.mix.unit": "/heure",
    "services.mix.note": "60€/h entre 22h et 8h",
    "services.prod.eyebrow": "Création",
    "services.prod.title": "Prod personnalisée",
    "services.prod.price": "à partir de 50€",
    "services.prod.desc":
      "Production sur-mesure. On compose votre instrumental selon votre style et vos références.",
    "services.mastering.eyebrow": "Finition",
    "services.mastering.title": "Mastering",
    "services.mastering.desc":
      "Mastering final pour rendre vos morceaux prêts pour la diffusion sur toutes les plateformes.",
    "services.mastering.unit": "/titre",

    "ba.eyebrow": "02 — Avant / Après",
    "ba.title": "Écoutez la différence.",
    "ba.subtitle":
      "Même prise, deux traitements : la version brute et la version mixée au studio. 30 secondes suffisent.",
    "ba.raw": "Brut · Sans mix",
    "ba.mixed": "Mixé · Ice Label",
    "ba.pop": "POP — Instrumental",
    "ba.pop.style": "Pop / Instru",
    "ba.blue": "Blue — Voix",
    "ba.blue.style": "Voix / Mix",
    "ba.joy": "Joy — Voix",
    "ba.joy.style": "Voix / Mix",

    "about.eyebrow": "03 — Le studio",
    "about.title": "Un espace dédié au son.",
    "about.p1":
      "Ice Label, c'est un studio installé à Anderlecht, à deux pas du centre de Bruxelles. On y enregistre, on y mixe, on y masterise — toujours dans le même esprit : livrer un son qui claque sans faire perdre de temps à l'artiste.",
    "about.p2":
      "Matos pro, écoute neutre, ambiance posée. On bosse aussi bien avec des artistes qui débutent qu'avec ceux qui ont déjà des sorties à leur compte.",
    "about.sessions": "Sessions",
    "about.sessionsV": "Sur RDV",
    "about.matos": "Matos",
    "about.matosV": "Pro",
    "about.loc": "Localisation",
    "about.locV": "Anderlecht",
    "about.badge": "Sessions ouvertes",

    "contact.eyebrow": "04 — Contact",
    "contact.title": "Appelez ou envoyez un SMS.",
    "contact.subtitle": "Réservation directe au même numéro — comme ça vous convient le mieux.",
    "contact.call": "Appeler",
    "contact.callSub": "Cliquez pour appeler — réservation immédiate",
    "contact.sms": "Envoyer un SMS",
    "contact.smsSub": "Réponse rapide, même numéro",
    "contact.email": "Email",
    "contact.hours.label": "Horaires d'ouverture",
    "contact.hours.value": "Lundi — Samedi · 9h → 21h",
    "contact.hours.sub": "Uniquement sur réservation · Fermé le dimanche",
    "contact.hours.night": "Sessions de nuit (22h → 8h) : tarif ×2",

    "admin.login.eyebrow": "Espace privé",
    "admin.login.title": "Ice Label — Admin",
    "admin.login.subtitle": "Connexion réservée à l'équipe du studio.",
    "admin.login.password": "Mot de passe",
    "admin.login.submit": "Se connecter",
    "admin.login.loading": "Connexion...",
    "admin.login.back": "← Retour au site",
    "admin.login.success": "Connexion réussie",
    "admin.login.wrong": "Mot de passe incorrect",
  },

  en: {
    "nav.services": "Services",
    "nav.extraits": "Samples",
    "nav.about": "Studio",
    "nav.contact": "Contact",
    "header.call": "Call",

    "hero.eyebrow": "Studio · Brussels · Anderlecht",
    "hero.slogan": "Where Music Lives",
    "hero.subtitle":
      "Professional recording studio. Mixing, custom production and mastering — built for artists who want a clean sound, ready for streaming.",
    "hero.callBtn": "Call",
    "hero.smsBtn": "Send an SMS",
    "hero.seeServices": "See pricing",
    "hero.reservationTitle": "Booking",
    "hero.reservationText":
      "Sessions confirmed by phone or SMS only. Open Monday to Saturday, 9am–9pm — by appointment only.",
    "hero.hours": "Mon–Sat · 9am–9pm",

    "services.eyebrow": "01 — Pricing",
    "services.title": "Three services. One standard: pro.",
    "services.desc":
      "Clear rates, no surprises. No subscriptions, no hidden bundles — you pay for the session, that's it.",
    "services.night": "Night sessions (10pm → 8am): rate ×2",
    "services.mix.eyebrow": "Mix",
    "services.mix.title": "Mix Session",
    "services.mix.desc":
      "Professional mixing of your tracks in studio. Sound engineer on-site, high-end monitoring.",
    "services.mix.unit": "/hour",
    "services.mix.note": "60€/h between 10pm and 8am",
    "services.prod.eyebrow": "Creation",
    "services.prod.title": "Custom Production",
    "services.prod.price": "from 50€",
    "services.prod.desc":
      "Tailor-made production. We compose your instrumental based on your style and references.",
    "services.mastering.eyebrow": "Finishing",
    "services.mastering.title": "Mastering",
    "services.mastering.desc":
      "Final mastering to make your tracks release-ready for every streaming platform.",
    "services.mastering.unit": "/track",

    "ba.eyebrow": "02 — Before / After",
    "ba.title": "Hear the difference.",
    "ba.subtitle":
      "Same take, two treatments: the raw version and the studio-mixed version. 30 seconds is enough.",
    "ba.raw": "Raw · Unmixed",
    "ba.mixed": "Mixed · Ice Label",
    "ba.pop": "POP — Instrumental",
    "ba.pop.style": "Pop / Instrumental",
    "ba.blue": "Blue — Vocals",
    "ba.blue.style": "Vocals / Mix",
    "ba.joy": "Joy — Vocals",
    "ba.joy.style": "Vocals / Mix",

    "about.eyebrow": "03 — The studio",
    "about.title": "A space dedicated to sound.",
    "about.p1":
      "Ice Label is a studio based in Anderlecht, a stone's throw from central Brussels. We record, mix and master — always with the same mindset: deliver a sound that hits, without wasting the artist's time.",
    "about.p2":
      "Pro gear, neutral monitoring, chill vibe. We work with beginners and artists who already have releases out.",
    "about.sessions": "Sessions",
    "about.sessionsV": "By appointment",
    "about.matos": "Gear",
    "about.matosV": "Pro",
    "about.loc": "Location",
    "about.locV": "Anderlecht",
    "about.badge": "Sessions open",

    "contact.eyebrow": "04 — Contact",
    "contact.title": "Call or send an SMS.",
    "contact.subtitle": "Direct booking on the same number — whichever suits you best.",
    "contact.call": "Call",
    "contact.callSub": "Tap to call — instant booking",
    "contact.sms": "Send an SMS",
    "contact.smsSub": "Quick reply, same number",
    "contact.email": "Email",
    "contact.hours.label": "Opening hours",
    "contact.hours.value": "Monday — Saturday · 9am → 9pm",
    "contact.hours.sub": "By appointment only · Closed on Sunday",
    "contact.hours.night": "Night sessions (10pm → 8am): rate ×2",
    "admin.login.title": "Ice Label — Admin",
    "admin.login.subtitle": "Access restricted to the studio team.",
    "admin.login.password": "Password",
    "admin.login.submit": "Sign in",
    "admin.login.loading": "Signing in...",
    "admin.login.back": "← Back to site",
    "admin.login.success": "Signed in",
    "admin.login.wrong": "Wrong password",
  },

  nl: {
    "nav.services": "Diensten",
    "nav.extraits": "Fragmenten",
    "nav.about": "Studio",
    "nav.contact": "Contact",
    "header.call": "Bellen",

    "hero.eyebrow": "Studio · Brussel · Anderlecht",
    "hero.slogan": "Where Music Lives",
    "hero.subtitle":
      "Professionele opnamestudio. Mix, productie op maat en mastering — gemaakt voor artiesten die een strakke sound willen, klaar voor de streamingplatformen.",
    "hero.callBtn": "Bellen",
    "hero.smsBtn": "Stuur een SMS",
    "hero.seeServices": "Tarieven bekijken",
    "hero.reservationTitle": "Reservering",
    "hero.reservationText":
      "Sessies enkel bevestigd via telefoon of SMS. Open van maandag tot zaterdag, van 9u tot 21u — enkel op afspraak.",
    "hero.hours": "Ma–Za · 9u–21u",

    "services.eyebrow": "01 — Tarieven",
    "services.title": "Drie diensten. Eén standaard: pro.",
    "services.desc":
      "Heldere tarieven, geen verrassingen. Geen abonnementen, geen verborgen pakketten — u betaalt de sessie, punt.",
    "services.night": "Nachtsessies (22u → 8u): tarief ×2",
    "services.mix.eyebrow": "Mix",
    "services.mix.title": "Mix-sessie",
    "services.mix.desc":
      "Professionele mix van uw tracks in de studio. Geluidsingenieur aanwezig, monitoring van hoge kwaliteit.",
    "services.mix.unit": "/uur",
    "services.mix.note": "60€/u tussen 22u en 8u",
    "services.prod.eyebrow": "Creatie",
    "services.prod.title": "Productie op maat",
    "services.prod.price": "vanaf 50€",
    "services.prod.desc":
      "Productie op maat. We componeren uw instrumentaal volgens uw stijl en referenties.",
    "services.mastering.eyebrow": "Afwerking",
    "services.mastering.title": "Mastering",
    "services.mastering.desc":
      "Definitieve mastering om uw tracks klaar te maken voor uitgave op alle platformen.",
    "services.mastering.unit": "/track",

    "ba.eyebrow": "02 — Voor / Na",
    "ba.title": "Hoor het verschil.",
    "ba.subtitle":
      "Zelfde opname, twee behandelingen: de ruwe versie en de gemixte studioversie. 30 seconden volstaat.",
    "ba.raw": "Ruw · Zonder mix",
    "ba.mixed": "Gemixt · Ice Label",
    "ba.pop": "POP — Instrumentaal",
    "ba.pop.style": "Pop / Instrumentaal",
    "ba.blue": "Blue — Vocalen",
    "ba.blue.style": "Vocalen / Mix",
    "ba.joy": "Joy — Vocalen",
    "ba.joy.style": "Vocalen / Mix",

    "about.eyebrow": "03 — De studio",
    "about.title": "Een ruimte gewijd aan geluid.",
    "about.p1":
      "Ice Label is een studio in Anderlecht, op een steenworp van het centrum van Brussel. We nemen op, mixen en masteren — altijd met dezelfde ambitie: een sound leveren die klopt, zonder de tijd van de artiest te verspillen.",
    "about.p2":
      "Pro apparatuur, neutrale monitoring, rustige sfeer. We werken zowel met beginnende artiesten als met wie al releases op zijn naam heeft.",
    "about.sessions": "Sessies",
    "about.sessionsV": "Op afspraak",
    "about.matos": "Materiaal",
    "about.matosV": "Pro",
    "about.loc": "Locatie",
    "about.locV": "Anderlecht",
    "about.badge": "Sessies open",

    "contact.eyebrow": "04 — Contact",
    "contact.title": "Bel of stuur een SMS.",
    "contact.subtitle": "Directe reservering op hetzelfde nummer — zoals het u het beste past.",
    "contact.call": "Bellen",
    "contact.callSub": "Klik om te bellen — directe reservering",
    "contact.sms": "Stuur een SMS",
    "contact.smsSub": "Snel antwoord, zelfde nummer",
    "contact.email": "E-mail",
    "contact.hours.label": "Openingsuren",
    "contact.hours.value": "Maandag — Zaterdag · 9u → 21u",
    "contact.hours.sub": "Enkel op afspraak · Zondag gesloten",
    "contact.hours.night": "Nachtsessies (22u → 8u): tarief ×2",

    "admin.login.eyebrow": "Privé-zone",
    "admin.login.title": "Ice Label — Admin",
    "admin.login.subtitle": "Toegang enkel voor het studio-team.",
    "admin.login.password": "Wachtwoord",
    "admin.login.submit": "Inloggen",
    "admin.login.loading": "Inloggen...",
    "admin.login.back": "← Terug naar site",
    "admin.login.success": "Ingelogd",
    "admin.login.wrong": "Verkeerd wachtwoord",
  },
};

const I18nContext = createContext({ lang: "fr", setLang: () => {}, t: (k) => k });

export function I18nProvider({ children }) {
  const [lang, setLangState] = useState(() => {
    if (typeof window === "undefined") return "fr";
    const saved = localStorage.getItem(STORAGE_KEY);
    return saved && translations[saved] ? saved : "fr";
  });

  const setLang = (l) => {
    if (!translations[l]) return;
    setLangState(l);
    localStorage.setItem(STORAGE_KEY, l);
  };

  useEffect(() => {
    document.documentElement.lang = lang;
  }, [lang]);

  const t = (key) => translations[lang]?.[key] ?? translations.fr[key] ?? key;

  return <I18nContext.Provider value={{ lang, setLang, t }}>{children}</I18nContext.Provider>;
}

export function useI18n() {
  return useContext(I18nContext);
}
